export default {
  countCells: 11,
  massive: [
    {
      dataField: 'npg0',
      cols: 2,
      rows: 2,
      text: 'УГСН (НПС)',
      class: 'd-flex flex-row align-center',
      headerClass: 'align-start justify-start',
      headerStyles: ``,
      variable: false,
    },
    {
      dataField: 'npg11',
      cols: 9,
      rows: 1,
      text: 'Контрольные цифры приема, установленные образовательной организации',
      headerClass: '',
      variable: false,
    },
    {
      dataField: 'npg12',
      cols: 3,
      rows: 1,
      text: 'на 2020/2021 учебный год',
      headerClass: '',
      variable: false,
    },
    {
      dataField: 'npg13',
      cols: 3,
      rows: 1,
      text: "на 2021/2022 учебный год",
      headerClass: '',
      variable: false,
    },
    {
      dataField: 'npg14',
      cols: 3,
      rows: 1,
      text: `на 2022/2023 учебный год`,
      headerClass: '',
      variable: false,
    },
    {
      dataField: 'x1',
      cols: 1,
      rows: 1,
      text: `код`,
      order: 2,
      variable: false,
    },
    {
      dataField: 'x2',
      cols: 1,
      rows: 1,
      text: `наименование`,
      order: 3,
      variable: false,
    },
    {
      dataField: 'npg34',
      cols: 1,
      rows: 1,
      text: `очно`,
      order: 4,
      variable: false,
    },
    {
      dataField: 'npg35',
      cols: 1,
      rows: 1,
      text: `очно-заочно`,
      order: 5,
      variable: false,
    },
    {
      dataField: 'npg36',
      cols: 1,
      rows: 1,
      text: `заочно`,
      order: 6,
      variable: false,
    },
    {
      dataField: 'npg37',
      cols: 1,
      rows: 1,
      text: `очно`,
      order: 7,
      variable: false,
    },
    {
      dataField: 'npg38',
      cols: 1,
      rows: 1,
      text: `очно-заочно`,
      order: 8,
      variable: false,
    },
    {
      dataField: 'npg39',
      cols: 1,
      rows: 1,
      text: `заочно`,
      order: 9,
      variable: false,
    },
    {
      dataField: 'npg310',
      cols: 1,
      rows: 1,
      text: `очно`,
      order: 10,
      variable: false,
    },
    {
      dataField: 'npg311',
      cols: 1,
      rows: 1,
      text: `очно-заочно`,
      order: 11,
      variable: false,
    },
    {
      dataField: 'npg312',
      cols: 1,
      rows: 1,
      text: `заочно`,
      order: 12,
      variable: false,
    },
    {
      dataField: 'npg',
      cols: 1,
      rows: 1,
      headerClass: 'd-flex flex-row justify-start pa-0 font-size-small__important',
      text: `1`,
      order: 13,
      variable: true,
      class: 'justify-start d-flex flex-row',
    },
    {
      dataField: 'x6',
      cols: 1,
      rows: 1,
      headerClass: 'd-flex flex-row justify-start pa-0 font-size-small__important',
      headerStyles: 'min-width: 300px',
      text: `2`,
      order: 14,
      variable: true,
      class: 'justify-start d-flex flex-row',
    },
    {
      dataField: 'qkcpo20K22',
      cols: 1,
      rows: 1,
      text: `3`,
      order: 15,
      headerClass: 'pa-0 font-size-small__important',
      variable: true,
      styles: 'justify-content: unset; text-align: center;',
      props: (row, cell, loading) => {
        return {
          value: row[cell.dataField],
          title: '',
          cell: cell,
          id: row.id,
          row: row,
          loading: loading,
        }
      },
    },
    {
      dataField: 'qkcpv20K22',
      cols: 1,
      rows: 1,
      text: `4`,
      order: 16,
      headerClass: 'pa-0 font-size-small__important',
      variable: true,
      styles: 'justify-content: unset; text-align: center;',
      props: (row, cell, loading) => {
        return {
          value: row[cell.dataField],
          title: '',
          cell: cell,
          id: row.id,
          row: row,
          loading: loading,
        }
      },
    },
    {
      dataField: 'qkcpz20K22',
      cols: 1,
      rows: 1,
      text: `5`,
      order: 17,
      headerClass: 'pa-0 font-size-small__important',
      variable: true,
      styles: 'justify-content: unset; text-align: center;',
      props: (row, cell, loading) => {
        return {
          value: row[cell.dataField],
          title: '',
          cell: cell,
          id: row.id,
          row: row,
          loading: loading,
        }
      },
    },
    {
      dataField: 'qkcpo21K22',
      cols: 1,
      rows: 1,
      text: `6`,
      order: 18,
      headerClass: 'pa-0 font-size-small__important',
      variable: true,
      styles: 'justify-content: unset; text-align: center;',
      props: (row, cell, loading) => {
        return {
          value: row[cell.dataField],
          title: '',
          cell: cell,
          id: row.id,
          row: row,
          loading: loading,
        }
      },
    },
    {
      dataField: 'qkcpv21K22',
      cols: 1,
      rows: 1,
      text: `7`,
      order: 19,
      headerClass: 'pa-0 font-size-small__important',
      variable: true,
      styles: 'justify-content: unset; text-align: center;',
      props: (row, cell, loading) => {
        return {
          value: row[cell.dataField],
          title: '',
          cell: cell,
          id: row.id,
          row: row,
          loading: loading,
        }
      },
    },
    {
      dataField: 'qkcpz21K22',
      cols: 1,
      rows: 1,
      text: `8`,
      order: 20,
      headerClass: 'pa-0 font-size-small__important',
      variable: true,
      styles: 'justify-content: unset; text-align: center;',
      props: (row, cell, loading) => {
        return {
          value: row[cell.dataField],
          title: '',
          cell: cell,
          id: row.id,
          row: row,
          loading: loading,
        }
      },
    },
    {
      dataField: 'qkcpo22K22',
      cols: 1,
      rows: 1,
      text: `9`,
      order: 21,
      headerClass: 'pa-0 font-size-small__important',
      variable: true,
      styles: 'justify-content: unset; text-align: center;',
      props: (row, cell, loading) => {
        return {
          value: row[cell.dataField],
          title: '',
          cell: cell,
          id: row.id,
          row: row,
          loading: loading,
        }
      },
    },
    {
      dataField: 'qkcpv22K22',
      cols: 1,
      rows: 1,
      text: `10`,
      order: 22,
      headerClass: 'pa-0 font-size-small__important',
      variable: true,
      styles: 'justify-content: unset; text-align: center;',
      props: (row, cell, loading) => {
        return {
          value: row[cell.dataField],
          title: '',
          cell: cell,
          id: row.id,
          row: row,
          loading: loading,
        }
      },
    },
    {
      dataField: 'qkcpz22K22',
      cols: 1,
      rows: 1,
      text: `11`,
      order: 23,
      headerClass: 'pa-0 font-size-small__important',
      variable: true,
      styles: 'justify-content: unset; text-align: center;',
      props: (row, cell, loading) => {
        return {
          value: row[cell.dataField],
          title: '',
          cell: cell,
          id: row.id,
          row: row,
          loading: loading,
        }
      },
    },
  ]
}
